export default ({
  to, next, store,
}) => {
  if (to.name === 'PartnerRequired' || store.state.partnerConfig?.partnerID !== '') {
    next();
    return;
  }
  next({ name: 'PartnerRequired' });
};
